import React, { useState, useRef, useEffect } from "react";

function UserDropdown({ user, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="user-dropdown" ref={dropdownRef}>
      <button className="user-button" onClick={toggleDropdown}>
        <span className="user-icon">👤</span>
        <span className="user-name">{user.name}</span>
        <span className="dropdown-arrow">{isOpen ? "▲" : "▼"}</span>
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="user-info">
            <div className="user-email">{user.email}</div>
            <div className="user-session">Session ID: {user.sessionId}</div>
          </div>

          <div className="dropdown-divider"></div>

          <div className="chatwoot-status-small">
            <div className="status-item">✅ Chatwoot configurado</div>
            <div className="status-item">🔒 HMAC ativado</div>
          </div>

          <div className="dropdown-divider"></div>

          <button className="logout-button-small" onClick={onLogout}>
            🚪 Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default UserDropdown;
